import React from 'react';
import * as Styled from './StyledProfileInfoReminder';
import { CA } from 'contexts';
import exclamationicon from 'assets/images/profile-info-reminder-exclamation.svg';

export const ProfileInfoReminder = () => {
    const { user } = React.useContext(CA).state;
    return (
        !!(!user.personalEmail || !user.phone) && (
            <Styled.ProfileInfoReminder>
                <Styled.Description>
                    <img src={exclamationicon} alt="exclamation icon" />
                    <p>
                        Você pode fornecer seus contatos pessoais, como whatsapp ou email, para
                        facilitar a comunicação com seus mentorados durante a fase de mentoria do
                        Programa 100-10-1 Startups.
                    </p>
                </Styled.Description>
                <Styled.Button href="/profile/edit">
                    <span className="text">REVISAR SEUS CONTATOS</span>
                </Styled.Button>
            </Styled.ProfileInfoReminder>
        )
    );
};
